var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.837 0 0 114.837 0 256C0 397.163 114.837 512 256 512C397.163 512 512 397.163 512 256C512 114.837 397.163 0 256 0ZM192 106.667H320C331.797 106.667 341.333 116.224 341.333 128C341.333 139.776 331.797 149.333 320 149.333H192C180.203 149.333 170.667 139.776 170.667 128C170.667 116.224 180.203 106.667 192 106.667ZM320 405.333H192C180.203 405.333 170.667 395.776 170.667 384C170.667 372.224 180.203 362.667 192 362.667H320C331.797 362.667 341.333 372.224 341.333 384C341.333 395.776 331.797 405.333 320 405.333ZM384 320H128C116.203 320 106.667 310.443 106.667 298.667C106.667 286.891 116.203 277.334 128 277.334H384C395.797 277.334 405.333 286.891 405.333 298.667C405.333 310.443 395.797 320 384 320ZM384 234.667H128C116.203 234.667 106.667 225.11 106.667 213.334C106.667 201.558 116.203 192 128 192H384C395.797 192 405.333 201.557 405.333 213.333C405.333 225.109 395.797 234.667 384 234.667Z",
    fill: "#0466C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.a24ad5c9480fbfd4cbc61f9556aac063.svg";
export { ForwardRef as ReactComponent };